import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Group from 'src/store/models/Group';
import GroupUser from 'src/store/models/GroupUser';
import ProjectGroup from 'src/store/models/ProjectGroup';
import { dialog } from 'src/boot/mixins';
import { colorUtils } from 'src/mixins/colors-utils';
import { cloneDeep, orderBy, filter, forEach, includes } from 'lodash';
export default {
  mixins: [dialog, colorUtils],
  components: {
    TeDialog: TeDialog
  },
  props: {
    groupId: {
      type: [Number, String]
    },
    onComplete: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  data: function data() {
    return {
      tab: 'info',
      isDirty: false,
      myGroup: null,
      loading: false,
      deletedProjects: [],
      deletedUsers: []
    };
  },
  watch: {
    myGroup: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && oldVal) {
          this.isDirty = true;
        }
      }
    }
  },
  computed: {
    group: function group() {
      return Group.query().withAll().find(this.groupId);
    }
  },
  methods: {
    deleteGroup: function deleteGroup() {
      var _this = this;

      this.loading = true;
      Group.api().delete('/groups/' + this.groupId, {
        delete: this.groupId
      }).then(function () {
        _this.$root.$emit('refresh-users');

        _this.$root.$emit('refresh-groups');

        _this.loading = false;

        _this.hide();

        _this.$q.notify({
          message: _this.$t('components.groupDialog.group_deleted'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    },
    show: function show() {
      var _this2 = this;

      this.$refs.dialog.show();

      if (this.groupId) {
        this.loading = true;
        Group.api().get('/groups/' + this.groupId).finally(function (response) {
          _this2.initData();

          _this2.loading = false;
        });
      } else {
        this.initData();
        this.loading = false;
      }
    },
    initData: function initData() {
      var _this3 = this;

      if (this.group) {
        this.myGroup = cloneDeep(this.group);
        this.myGroup.projects = orderBy(this.myGroup.projects, ['name', 'asc']);
      } else {
        this.myGroup = {
          name: null,
          color: this.getRandomColor()
        };
      }

      this.$nextTick(function () {
        _this3.isDirty = false;
      });
    },
    save: function save() {
      var _this4 = this;

      this.loading = true;

      if (this.groupId) {
        Group.api().put('/groups/' + this.groupId, {
          name: this.myGroup.name,
          color: this.myGroup.color,
          users: this.myGroup.users,
          projects: this.myGroup.projects
        }).then(function (_ref) {
          var response = _ref.response;

          _this4.initData();

          _this4.myGroup.projects = filter(_this4.myGroup.projects, function (project) {
            return !includes(_this4.deletedProjects, project.project_id);
          });
          _this4.myGroup.users = filter(_this4.myGroup.users, function (user) {
            return !includes(_this4.deletedUsers, user.user_id);
          });
          forEach(_this4.deletedProjects, function (deletedProject) {
            ProjectGroup.delete([deletedProject, _this4.myGroup.group_id]);
          });
          forEach(_this4.deletedUsers, function (deletedUser) {
            GroupUser.delete([_this4.myGroup.group_id, deletedUser]);
          });
          Group.update({
            where: _this4.myGroup.group_id,
            data: {
              projects_count: _this4.myGroup.projects.length,
              users_count: _this4.myGroup.users.length
            }
          });

          _this4.$root.$emit('refresh-groups');

          _this4.$root.$emit('refresh-users');

          _this4.onComplete(response.data);

          _this4.loading = false;

          _this4.$q.notify({
            message: _this4.$t('general.has_been_updated', {
              el: _this4.myGroup.name
            }),
            type: 'positive'
          });
        }).catch(function () {}).finally(function () {
          _this4.deletedProjects = [];
          _this4.deletedUsers = [];
          _this4.loading = false;
        });
      } else {
        Group.api().post('/groups', {
          name: this.myGroup.name,
          color: this.myGroup.color
        }).then(function (_ref2) {
          var response = _ref2.response;

          _this4.hide();

          _this4.$root.$emit('refresh-users');

          _this4.onComplete(response.data);

          _this4.$q.notify({
            message: _this4.$t('components.groupDialog.group_created', {
              name: _this4.myGroup.name
            }),
            type: 'positive'
          });
        }).catch(function () {}).finally(function () {
          _this4.loading = false;
        });
      }
    },
    markForDeletion: function markForDeletion(project, index) {
      if (!project.new) {
        this.$set(project, 'delete', true);
        this.deletedProjects.push(project.project_id);
      } else {
        this.myGroup.projects.splice(index, 1);
      }
    },
    undoDeletion: function undoDeletion(project, index) {
      this.$set(project, 'delete', false);
      this.deletedProjects = filter(this.deletedProjects, function (deletedProject) {
        return deletedProject !== project.project_id;
      });
    },
    markUserForDeletion: function markUserForDeletion(user, index) {
      if (!user.new) {
        this.$set(user, 'delete', true);
        this.deletedUsers.push(user.user_id);
      } else {
        this.myGroup.users.splice(index, 1);
      }
    },
    undoUserDeletion: function undoUserDeletion(user, index) {
      this.$set(user, 'delete', false);
      this.deletedUsers = filter(this.deletedUsers, function (deletedUser) {
        return deletedUser !== user.user_id;
      });
    },
    addUsers: function addUsers(users) {
      var _this5 = this;

      forEach(users, function (user) {
        user.group_id = _this5.myGroup.group_id;
        user.pivot = {
          is_gm: 0
        };
      });
      this.myGroup.users = orderBy([].concat(_toConsumableArray(this.myGroup.users), _toConsumableArray(users)), ['name', 'asc']);
    },
    addProjects: function addProjects(projects) {
      this.myGroup.projects = orderBy([].concat(_toConsumableArray(this.myGroup.projects), _toConsumableArray(projects)), ['name', 'asc']);
    }
  }
};